import t from '../translate';

export const TYPE = {
  VIP_INVESTIGATION: 'vip_investigation',
  THREAT_LANDSCAPE_REPORT: 'threat_landscape_report',
  INDUSTRY_EXPERTISE: 'industry_expertise',
  REGIONAL_EXPERTISE: 'regional_expertise',
  INCIDENT_REPORT: 'incident_report',
  ALERT_REPORT: 'alert_report',
  THREAT_ACTOR_INVESTIGATION: 'threat_actor_investigation',
  PURCHASE: 'purchase',
  THREAT_INVESTIGATION: 'threat_investigation',
  PHISHING_CAMPAIGN: 'phishing_campaign',
  HUMINT_INVESTIGATION: 'humint_investigation',
  SOCIAL_MEDIA_MAPPING: 'social_media_mapping',
  OTHER: 'other'
};

const invOption = value => ({
  key: value,
  value,
  label: t(`investigation_type.${value}`),
  tooltip: t(`investigation_type.${value}_description`)
});
export const TYPE_OPTIONS = Object.values(TYPE).map(invOption);

export const STATUS = {
  INITIATED: 'initiated',
  RECEIVED: 'received',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};
const statusMetaData = {
  [STATUS.INITIATED]: { color: 'var(--darkGoldenrod)' },
  [STATUS.RECEIVED]: { color: 'var(--slateBlue)' },
  [STATUS.IN_PROGRESS]: { color: 'var(--brandeisBlue)' },
  [STATUS.COMPLETED]: { color: 'var(--midnightGreen)' },
  [STATUS.CANCELLED]: { color: 'var(--lust)' }
};
const statusOption = value => ({
  key: value,
  value,
  dotColor: statusMetaData[value].color,
  label: t(`investigation_status.${value}`)
});
export const STATUS_OPTIONS = Object.keys(statusMetaData).map(statusOption);

const SM_CHANNEL = {
  WHATS_APP: 'WhatsApp',
  TEAMS: 'Teams',
  SLACK: 'Slack',
  TELEGRAM: 'Telegram'
};
export const CHANNEL = {
  ALERT_DISCUSSION_BOARD: 'alert_discussion_board',
  EMAIL: 'email',
  MEETINGS: 'meetings',
  SUPPORT_TICKET: 'support_ticket',
  ...SM_CHANNEL
};
export const ALERT_CHANNEL = 'alert';

const channelOption = value => ({
  key: value,
  value,
  label: Object.values(SM_CHANNEL).includes(value) ? value : t(`investigation_channel.${value}`)
});
export const CHANNEL_OPTIONS = Object.values(CHANNEL).map(channelOption);
